<template>
    <div id="app-wrap">
        <ModalWindow/>    
        <Site-Header/>
        <MobileMenu/>
        <main>
        <div :class="'outer-main-wrap ' + (uiStore.darkMode ? 'dark-mode' : 'light-mode')">
            <DarkModeToggle/>
            <div class="not-found-wrap inner-wrap">
                <h1>{{ errorCode }}: {{ errorMessage }}</h1>
                <p>
                    Oops! Looks like you've hit a snag. <br>
                    The page or resource you're searching for may be unavailable or moved. <br>
                    Don't worry, we're on it.
                </p>
                <p>
                <ContactHint/>
                </p>
            </div>
            <FooterMenu/>
            <BackToTop/>
        </div>
        </main>
        <Site-Footer/>
        <CookiePopup/>
        <LiveChat/>
        <Popup/>
  </div>
</template>

<script setup lang="ts">
import { useUIStore } from '~/store/uiStore';

const uiStore = useUIStore();

// Added props definition
const props = defineProps({
    errorCode: Number,
    errorMessage: String,
});

</script>

<style lang="scss" scoped>
p {
    font-size: 1.25rem;
    margin-bottom: 1rem;
}
</style>